import { useEffect, useState } from 'react';
type Props<T> = {
  load: () => Promise<{ default: T }>;
  children: (props: { loaded: false; data: null } | { loaded: true; data: T }) => any;
};

export default function LazyLoad<T>({ load, children }: Props<T>) {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let result: any = await load();
      if (result.__esModule) result = result.default;
      if (!cancelled) setData(result);
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children(data ? { loaded: true, data } : { loaded: false, data: null });
}
